import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HoppersCafeGalleryPage = ({ components }) => {
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCafeGalleryPage-header":
                return <div className="HoppersCafeGalleryPage-header">{component?.Props?.text}</div>
            case "HoppersCafeGalleryPage-subheader":
                return <div className="HoppersCafeGalleryPage-subheader">{component?.Props?.text}</div>
            case "HoppersCafeGalleryPage-grid":
                return <div className="HoppersCafeGalleryPage-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <img
                                src={data?.src}
                                key={key}
                                alt=""
                                className="HoppersCafeGalleryPage-grid-image" />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCafeGalleryPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HoppersCafeGalleryPage